import { CheckCircle, Circle, Truck, Box, Edit } from "lucide-react";  // Import additional icons

interface Step {
  label: string;
  name: string;
  icon: React.ReactNode;  // Add icon property for each step
}

interface ProgressTrackerProps {
  steps: Step[];
  currentStep: string;
}

const ProgressTracker = ({ steps, currentStep }: ProgressTrackerProps) => {

  // Get the index of the currentStep from the steps array
  const currentStepIndex = steps.findIndex(step => step.name === currentStep);

  return (
    <div className="flex items-center justify-between w-full">
      {steps.map((step, index) => {
        // Determine if the step is completed based on its index
        const isCompleted = currentStepIndex >= index;
        return (
          <div key={index} className="flex items-center justify-center flex-col mt-5">
            <div
              className={`flex items-center justify-center p-3 rounded-full  ${
                isCompleted ? "bg-green-500 text-white" : "bg-gray-300 text-gray-500"
              }`}
            >
              {/* Use the icon from the step */}
              {isCompleted ? <CheckCircle size={24} /> : step.icon}
            </div>
            <div
              className={`text-xs ml-2 ${
                isCompleted ? "text-green-500 font-semibold" : "text-gray-500"
              }`}
            >
              {step.label}
            </div>
            {index < steps.length - 1 && (
              <div
                className={`flex-1 h-1 mx-2 ${
                  isCompleted ? "bg-green-500" : "bg-gray-300"
                }`}
              ></div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default ProgressTracker;
